{
    "InlineExitMessage": "Siete sicuri di voler chiudere questa finestra? Tutte le configurazioni modificate andranno perse una volta chiuse.",
    "InlineExitConfirm": "Confermare",
    "InlineExitCancel": "Annullamento",
    "NotificationsModalTitle": "Notifiche",
    "TabSettingsTitle": "Impostazioni",
    "TabSettingsDoNotDisturb": "Abilitazione",
    "TabSettingsCME": "ECM",
    "TabSettingsTelServer": "Server di telefonia",
    "TabSettingsPartition": "Partizione \/ Sito",
    "TabSettingsDevices": "Dispositivi",
    "TabSettingsChannels": "Canali",
    "TabSettingsPhoneNumber": "Numero di telefono",
    "TabSettingsHeaderGeneral": "Generale",
    "TabSettingsHeaderScopeFiltering": "Filtraggio dell'ambito",
    "TabSettingsNotificationChannels": "Canali di notifica",
    "TabSetttingsPartitionValidation": "È possibile selezionare solo fino a 5 partizioni.",
    "TabPreferencesTitle": "Preferenze",
    "TabPreferencesHeadingUserNotifications": "Notifiche per gli utenti",
    "IconAddTooltip": "Aggiungi notifiche",
    "IconDisabledTooltip": "Le notifiche sono disattivate",
    "IconEnabledTooltip": "Le notifiche sono abilitate",
    "IconDisabled": "Disabili",
    "NotificationsFooterHelp": "Aiuto",
    "NotificationsFooterCancel": "Annullamento",
    "NotificationsFooterSubmit": "Risparmiare",
    "NotificationsFooterValiationWarning": "Correggere gli errori prima di terminare",
    "NotificationPrefereencesThreshholdPlaceholder": "Segnaposto",
    "NotificationPrefereencesThreshholdRequired": "La soglia è necessaria",
    "NotificationPrefereencesThreshholdInvalid": "La soglia deve essere un numero",
    "NotificationFooterValidationError": "Errori di convalida",
    "NAME": "NotificationsLanguageModal"
}